// src/components/store/sections/faqs/FaqV100ClaytogglesFuchsiaGlow.tsx
"use client";

import React from "react";
import DynamicFaqVariant from "./DynamicFaqVariant";

export default function FaqV100ClaytogglesFuchsiaGlow(props: any) {
  return (
    <DynamicFaqVariant
      variantNumber={100}
      archKey="clay_toggles"
      archLabel="3D Claymorphic Toggles"
      palName="FuchsiaGlow"
      grad="from-fuchsia-500 via-pink-500 to-purple-700"
      lightBg="bg-fuchsia-50"
      textCol="text-fuchsia-700"
      borderCol="border-fuchsia-200"
      btnCls="bg-fuchsia-600 hover:bg-fuchsia-700"
      hexCol="#d946ef"
      {...props}
    />
  );
}
